import { render } from "./completeOrder.vue?vue&type=template&id=5b8b0309"
import script from "./completeOrder.vue?vue&type=script&lang=js"
export * from "./completeOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__